/**
 * @fileoverview CSS module for the NavigationButton component.
 * Provides styling for navigation buttons with consistent dimensions and positioning.
 *
 * @example
 * // Usage in a component:
 * import styles from './NavigationButton.module.css'
 *
 * function NavigationButton() {
 *   return <button className={styles.button}>Click me</button>
 * }
 */

@keyframes spinner {
    0% {
        transform: rotate(0turn);
    }

    100% {
        transform: rotate(1turn);
    }
}

.button {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    height: 56px;
    border-radius: 12px;
    padding: 16px 32px;
    font-size: 20px;
    font-family: 'Inter', 'system-ui';
    font-weight: 400;
    border: none;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
}

.button:disabled {
    border: none;
}

.button:focus {
    outline: 0;
}

.button:not(:disabled):hover,
.button:not(:disabled):focus {
    box-shadow: 0px 0px 0px 6px var(--indigo300);
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-thickness: 1px;
    transition: all 200ms ease-out;
}

.confirm:not(:disabled):active {
    background-color: var(--indigo800);
}

.cancel:not(:disabled):active,
.confirm:not(:disabled):active {
    box-shadow: none;
}

.spinner {
    position: absolute;
    animation-name: spinner;
    animation-duration: 500ms;
    animation-timing-function: ease-out;
    animation-iteration-count: infinite;
}

.confirm {
    background-color: var(--indigo700);
    color: white;
}

.confirm:disabled {
    background-color: var(--indigo100);
}

.confirm:disabled span {
    visibility: hidden;
}

.confirm:focus {
    background-color: var(--indigo800);
}

.button:active {
    box-shadow: none;
}

.cancel {
    background-color: var(--neutural000);
    border: 1px solid var(--neutural400);
    color: var(--neutural900);
}

.cancel:disabled {
    background-color: var(--neutural100);
}

.cancel:disabled span {
    visibility: hidden;
}

.cancel:not(:disabled):hover,
.cancel:not(:disabled):focus {
    border: 1px solid var(--neutural900);
}

@media only screen and (min-width: 768px) {
    .button {
        flex-grow: 0;
    }
}
